export default "__VITE_ASSET__BotKxxo7__"